import React from "react";
import { Link } from "react-router-dom";
import { Banner } from "../../types/store";
import { resolveMediaUrl } from "../../utils/mediaUrl";

interface OfferBannerStripProps {
  banners: Banner[];
  title: string;
  columns?: 3 | 4;
}

const OfferBannerStrip: React.FC<OfferBannerStripProps> = ({ banners, title, columns = 3 }) => {
  if (!banners.length) {
    return null;
  }

  return (
    <section
      className={`shell section home-offer-banner-section home-offer-banner-section--${columns}`}
      aria-label={title}
    >
      <div className="home-offer-banner-grid" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
        {banners.slice(0, columns).map((banner) => (
          <Link
            key={banner.id}
            className="home-offer-banner-card"
            to={`/products?discover=1&view=collection${banner.slug ? `&promo=${encodeURIComponent(banner.slug)}` : ""}${banner.heading ? `&title=${encodeURIComponent(banner.heading)}` : ""}`}
          >
            <img src={resolveMediaUrl(banner.imageUrl)} alt={banner.heading?.trim() || title} />
          </Link>
        ))}
      </div>
    </section>
  );
};

export default OfferBannerStrip;
